import { CampaignStatus } from '@/types/states';

interface CampaignStatusBadgeProps {
  status: CampaignStatus | string;
  completedReferents?: number;
  totalReferents?: number;
}

export const CampaignStatusBadge = ({
  status,
  completedReferents,
  totalReferents,
}: CampaignStatusBadgeProps) => {
  const getStatusConfig = (currentStatus: CampaignStatus | string) => {
    switch (currentStatus) {
      case CampaignStatus.BROUILLON:
        return {
          outlineColor: 'outline-gray-500',
          textColor: 'text-gray-500',
          capitalize: true,
        };
      case CampaignStatus.EN_ATTENTE_CANDIDAT:
      case 'En attente candidat':
        return {
          outlineColor: 'outline-yellow-400',
          textColor: 'text-yellow-400',
          capitalize: false,
        };
      case CampaignStatus.EN_ATTENTE_REFERENTS:
      case 'En attente référent(s)':
        return {
          outlineColor: 'outline-teal-400',
          textColor: 'text-teal-400',
          capitalize: false,
        };
      case CampaignStatus.TERMINE:
      case 'Terminé':
        return {
          outlineColor: 'outline-green-500',
          textColor: 'text-green-500',
          capitalize: true,
        };
      case CampaignStatus.ANNULEE:
      case 'Annulée':
        return {
          outlineColor: 'outline-orange-500',
          textColor: 'text-orange-500',
          capitalize: true,
        };
      case CampaignStatus.REFUSE:
      case 'Refusé':
        return {
          outlineColor: 'outline-rose-500',
          textColor: 'text-rose-500',
          capitalize: true,
        };
      default:
        return {
          outlineColor: 'outline-gray-500',
          textColor: 'text-gray-500',
          capitalize: true,
        };
    }
  };

  const getStatusContent = () => {
    const config = getStatusConfig(status);

    if (
      (status === CampaignStatus.EN_ATTENTE_REFERENTS ||
        status === 'En attente référent(s)') &&
      completedReferents !== undefined &&
      totalReferents !== undefined
    ) {
      return (
        <div className="justify-start">
          <span className={`${config.textColor} text-xs font-medium uppercase tracking-tight`}>
            E
          </span>
          <span className={`${config.textColor} text-xs font-medium lowercase tracking-tight`}>
            n attente référent(s) {completedReferents}/{totalReferents}
          </span>
        </div>
      );
    }

    if (status === CampaignStatus.EN_ATTENTE_CANDIDAT || status === 'En attente candidat') {
      return (
        <div className="justify-start">
          <span className={`${config.textColor} text-xs font-medium uppercase tracking-tight`}>
            E
          </span>
          <span className={`${config.textColor} text-xs font-medium lowercase tracking-tight`}>
            n attente candidat
          </span>
        </div>
      );
    }

    return (
      <div
        className={`justify-start ${config.textColor} text-xs font-medium ${config.capitalize ? 'capitalize' : ''} tracking-tight`}
      >
        {status}
      </div>
    );
  };

  const config = getStatusConfig(status);

  return (
    <div
      className={`inline-flex items-center justify-center gap-2.5 rounded-md px-2 py-[5px] outline outline-1 outline-offset-[-1px] ${config.outlineColor}`}
    >
      {getStatusContent()}
    </div>
  );
};
